import { render, staticRenderFns } from "./NovoAnexoGenerico.vue?vue&type=template&id=1e2f2f9e"
import script from "./NovoAnexoGenerico.vue?vue&type=script&lang=js"
export * from "./NovoAnexoGenerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports